import React from 'react';
import '../styles/App.css';
import store from '../redux/Store';
import { Provider } from 'react-redux';
import { autentication } from '../repository/Firestore.config';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ChatMobile,Chat } from './pages';


function App(){
  autentication()
  return (
    <Provider store={store}>
      <Router>
        <Switch>
            <Route exact path="/" component={Chat} />
            <Route path="/chat" component={ChatMobile}/>
        </Switch>
      </Router>
    </Provider> 
  );
}

export default App;
